<template>
  <div class="login" :style="{ height: documentClientHeight }">
    <div class="logo"></div>
    <div class="login-content">
      <div class="lc-name">Hi！欢迎登录</div>
      <el-form
        :model="dataForm"
        :rules="rules"
        @keyup.enter="formSubmit"
        ref="dataForm"
      >
        <div class="lc-main">
          <div class="way">
            <span
              :class="{ active: loginWay === 'username' }"
              @click="loginWay = 'username'"
            >账号登录</span>
            <span
              :class="{ active: loginWay === 'phone' }"
              @click="loginWay = 'phone'"
            >手机登录</span>
            <span
              :class="{ active: loginWay === 'wechat' }"
              @click="switchWechatLogin"
            >扫码登录</span>
          </div>
          <template v-if="loginWay === 'username'">
            <el-form-item prop="userName">
              <el-input
                v-model="dataForm.userName"
                placeholder="请输入登录账号"
              ></el-input>
            </el-form-item>

            <el-form-item class="password" prop="password">
              <el-input
                type="password"
                v-model="dataForm.password"
                placeholder="请输入6-18位，包含大小写字母、数字的密码"
              ></el-input>
            </el-form-item>
            
            <el-form-item class="checked">
              <el-checkbox v-model="checked">记住密码</el-checkbox>
              <p class="forgot-password"><span @click="loginWay = 'phone'">新用户注册</span> <span class="line"></span> <span @click="forgotPassword">忘记密码?</span></p>
            </el-form-item>

            <el-button
              class="login-btn-submit"
              type="primary"
              @click="loginSubmit"
              :loading="isloading"
            >登录</el-button>
          </template>

          <template v-else-if="loginWay === 'phone'">
            <el-form-item prop="username">
              <el-input
                v-model="dataForm.username"
                type="number"
                autocomplete="off"
                placeholder="请输入手机号码"
              ></el-input>
            </el-form-item>

            <el-form-item class="captcha" prop="captcha">
              <el-input
                v-model="dataForm.captcha"
                type="number"
                autocomplete="off"
                placeholder="请输入手机验证码"
              >
                <template #append>
                  <el-button
                    style="width:150px;"
                    :disabled="isCodeDisabled"
                    @click="checkedPhoneCode"
                  >{{ phoneCodeBtn }}</el-button>
                </template>
              </el-input>
            </el-form-item>
            <p class="sign-tips">新用户首次使用手机验证码登录，等同于注册。</p>
            <el-button
              class="login-btn-submit"
              type="primary"
              @click="regSubmit"
              :loading="isloading"
            >注册/登录</el-button>
          </template>

          <template v-else-if="loginWay === 'wechat'">
            <div class="login-qrcode" id="loginQrcode"></div>
          </template>

          <div class="scan-login">
            <p> <ab-svg name="info"></ab-svg> 推荐使用 <span @click="goDownload">“谷歌浏览器”</span> 进入系统！ </p>
          </div>
        </div>
      </el-form>
    </div>
    <div class="about">
      <i></i>
      <a href="https://www.z-easy.com.cn/" target="_blank">关于一咻</a>
    </div>

    <!-- 选择租户 -->
    <el-dialog title="请选择租户" v-model="dialog" width="30%">
      <div class="radio-box">
        <el-radio-group v-model="tenantId">
          <el-radio v-for="(item, i) in tenants" :key="i" :label="i">{{
            item.tenantName
          }}</el-radio>
        </el-radio-group>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialog = false">取 消</el-button>
          <el-button type="primary" :loading="setTenantState" @click="setTenant"
            >确 定</el-button
          >
        </span>
      </template>
    </el-dialog>

    <!-- 重置密码 -->
    <el-dialog
      width="30%"
      append-to-body
      title="设置密码"
      :show-close="false"
      v-model="password.show"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="resetPassword"
    >
      <el-form
        :model="password.data"
        status-icon
        :rules="password.rules"
        ref="passwordForm"
        label-width="100px"
      >
        <el-form-item label="密码：" prop="pass">
          <el-input
            type="password"
            v-model="password.data.pass"
            placeholder="请输入6-18位，包含大小写字母、数字的密码"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码：" prop="checkPass">
          <el-input
            type="password"
            v-model="password.data.checkPass"
            placeholder="请再次输入6-18位，包含大小写字母、数字的密码"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="closePassword">取 消</el-button>
          <el-button
            type="primary"
            :loading="password.loading"
            @click="resetPassword"
            >确 定</el-button
          >
        </span>
      </template>
    </el-dialog>

    <!-- 绑定账号 -->
    <el-dialog
      title="绑定账号"
      v-model="bindDialog"
      :before-close="bindDialogClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="30%"
    >
      <div>
        <p style="margin-bottom:15px;text-align:center;">
          首次扫码登录，请绑定您的账号
        </p>
        <el-form
          :model="bindForm"
          :rules="rules"
          ref="bindForm"
          class="bindForm"
          size="small"
          label-width="60px"
          @keyup.enter="bindFormSubmit"
          status-icon
        >
          <el-form-item
            label="账号："
            prop="userName"
            :rules="rules.userName"
          >
            <el-input v-model="bindForm.userName" clearable></el-input>
          </el-form-item>
          <el-form-item
            label="密码："
            prop="password"
            :rules="rules.password"
          >
            <el-input
              v-model="bindForm.password"
              type="password"
              clearable
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <template #footer>
        <span class="dialog-footer">
          <el-button @click="bindDialogClose">取 消</el-button>
          <el-button type="primary" :loading="bindLoading" @click="bindFormSubmit"
            >绑定</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import vueCookie from 'vue-cookies'
export default {
  data() {
    const validatePass = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入密码"));
      } else {
        if (/(\w)\1\1/g.test(value)) {
          return callback(new Error("密码设置过弱，请重新设置"));
        }
        let reg = new RegExp('^(?:(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])).{6,18}$')
        if (!reg.test(value)) {
          return callback(new Error('请输入6-18位，包含大小写字母、数字的密码'))
        }
        // const LxStr = str => {
        //   const arr = str.split("");
        //   let flag = false;
        //   for (let i = 1; i < arr.length - 1; i++) {
        //     const firstIndex = arr[i - 1].charCodeAt();
        //     const secondIndex = arr[i].charCodeAt();
        //     const thirdIndex = arr[i + 1].charCodeAt();
        //     if (
        //       thirdIndex - secondIndex === 1 &&
        //       secondIndex - firstIndex === 1
        //     ) {
        //       flag = true;
        //     }
        //   }
        //   return flag;
        // };

        // if (LxStr(value)) {
        //   return callback(new Error("密码不允许出现连续3位递增字符"));
        // }

        if (this.password.data.checkPass !== "") {
          this.$refs.passwordForm.validateField("checkPass");
        }
        callback();
      }
    };

    const validatePass2 = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.password.data.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    return {
      documentClientHeight: '400px',
      cnAddress: '', //登录地址
      loginRemoteIp: '', //登录IP
      mac: '', // mac地址
      routeQuery: {},
      redirect_uri: '',
      loginWay: 'username',
      dataForm: {},
      rules: {        
        userName: [
          { required: true, message: '帐号不能为空', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' }
        ],
        username: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value) {
                if (!/^1[0-9]{10}$/.test(value)) {
                  callback(new Error('手机号码错误'));
                }
              }
              callback();
            },
            trigger: 'blur'
          }
        ],
        captcha: [
          { required: true, message: '请输入手机验证码', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value) {
                if (value.length !== 5) {
                  callback(new Error('验证码错误'));
                }
              }
              callback();
            },
            trigger: 'blur'
          }
        ]
      },
      phoneCodeBtn: '获取手机验证码',
      isCodeDisabled: false,
      checked: true,
      setTenantState: false,
      dialog: false,
      password: {
        show: false,
        loading: false,
        data: {},
        rules: {
          pass: [{ validator: validatePass, trigger: 'blur' }],
          checkPass: [{ validator: validatePass2, trigger: 'blur' }]
        }
      },
      tenant: '',
      tenantId: '',
      tenants: [],
      bindDialog: false,
      bindLoading: false,
      bindForm: {
        userName: '',
        password: '',
        openId: ''
      },
      isloading: false
    }
  },

  computed: {
    activeMenu: {
        get () {
            return this.$store.state.activeMenu
        },
        set (val) {
            this.$store.commit('updateActiveMenu', val)
        }
    },
    mainTabs: {
        get () { return this.$store.state.mainTabs },
        set (val) { this.$store.commit('updateMainTabs', val) }
    },
    mainTabsActiveName: {
        get () { return this.$store.state.mainTabsActiveName },
        set (val) { this.$store.commit('updateMainTabsActiveName', val) }
    },
  },

  watch: {
    $route(to, from) {
      if (to.query && to.query.code) {
        this.wechatQRCodeLogin(to.query.code)
      }
    }
  },

  created() {
    this.cnAddress = window.returnCitySN ? window.returnCitySN['cname'] : '' //登录地址
    this.loginRemoteIp = window.returnCitySN ? window.returnCitySN['cip'] : '' //登录IP
    this.mac = '' // mac地址
    console.log(this.cnAddress, this.loginRemoteIp)
    var isMobi = navigator.userAgent.toLowerCase().match(
    /(ipod|ipad|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|wince|microMessenger)/i
    ) != null
    if (isMobi) {
        let paths = window.location.href
        let parame = ''
        if (paths.indexOf('?') != -1) {
            parame = paths.substring(paths.indexOf('?'))
        }
        let url = ''
        switch (process.env.VUE_APP_ENV) {
            case 'prod':
                url = 'https://h5.z-easy.com.cn/#/register'
                break
            case 'uat':
                url = 'http://h5.uat.z-easy.com.cn/#/register'
                break
            case 'uat3':
                url = 'http://h5.uat3.z-easy.com.cn/#/register'
                break
            case 'test':
                url = 'http://h5.test.z-easy.com.cn/#/register'
                break
            case 'dev':
                url = 'http://h5.dev.z-easy.com.cn/#/register'
                break
        }
        window.location.href = url + parame
    }
    setTimeout(() => {
      this.$nextTick(() => {
        if(window.location.href.indexOf('oldWx') != -1) {
          this.switchWechatLogin()
        }
      })
    }, 1000);
  },

  mounted() {
    this.documentClientHeight = document.documentElement['clientHeight'] + 'px'
    window.onresize = () => {
      this.documentClientHeight = document.documentElement['clientHeight'] + 'px'
    }

    let query = this.$route.query || {}
    this.routeQuery = Object.keys(query).length ? query : this.routeQuery
    this.redirect_uri = encodeURIComponent(window.location.href)
    // 引入微信登录JS
    const wxScript = document.createElement('script')
    wxScript.type = 'text/javascript'
    wxScript.src = 'https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js'
    document.body.appendChild(wxScript)
    this.getAccount()
  },
  
  methods: {
    //谷歌浏览器官网
    goDownload() {
      open('https://www.google.cn/chrome/index.html')
    },
    forgotPassword() {
      this.$router.push({ path: '/forgot-password' })
    },

    getAccount() {
      var curTime = new Date().getTime()
      var data = localStorage.getItem('information')
      var dataObj = JSON.parse(data)
      if (data) {
        if (curTime - dataObj.time > 1000 * 60 * 60 * 24 * 7) {
          localStorage.removeItem('information')
        } else {
          this.dataForm.userName = dataObj.data.userName
          this.dataForm.password = dataObj.data.password
          this.checked = true
        }
      }
    },

    formSubmit() {
      if (this.loginWay === 'username') {
        this.loginSubmit()
      } else if (this.loginWay === 'phone') {
        this.regSubmit()
      }
    },

    loginSubmit() {
      this.$refs.dataForm.validate(valid => {
        if (valid) {
          this.isloading = true
          this.$post('/gateway/auth', {
            username: this.dataForm.userName,
            password: this.dataForm.password,
            loginType: 'pc',
            loginMode: 'mm',
            clientSource: '2',
            cnAddress: this.cnAddress,
            loginRemoteIp: this.loginRemoteIp
          }).then(({ data }) => {
            if (data && data.code === 'C0000') {
              if (data.result.isPwdExpired || (this.loginWay === 'phone' && !data.result.loginAuthDto.isChangedPwd)) {
                this.password.show = true
                this.password.data.userId = data.result && data.result.loginAuthDto ? data.result.loginAuthDto.userId || '' : ''
              } else {
                this.authAfter(data)
              }
            }
          }).finally(() => {
            setTimeout(() => {
              this.isloading = false
            }, 1000)
          })
        }
      })
    },

    authAfter(data) {
      this.setAccount()
      vueCookie.set('token', data.result.token, {
        domain: process.env.VUE_APP_DOADMIN
      });
      let accountId = data.result.loginAuthDto.accountId
      this.ActionsLoginId(accountId)
      this.activeMenu = ''
      this.mainTabs = []
      this.mainTabsActiveName = ''
      this.$utils.setSessionStorage('bizType', {
        clientImportRole: false,
        clientExportRole: false,
        clientWmsRole: false,
        activeIndex: '00'
      })
      // 初始化sessionStorage数据
      this.$initSessionStorageData.init()

      if (data.result.loginAuthDto.isAdmin) {
        this.$get('/p/user/getUsersByAccountId', { id: accountId }).then(({ data }) => {
          let userId = data.result[0].id
          this.ActionsUserId(userId)
          // 初始化sessionStorage数据
          this.$initSessionStorageData.init()
          
          this.$router.replace({
            path: '/',
            query: {
              isOuter: data.result[0].isOuter
                ? data.result[0].isOuter
                : ''
            }
          })
        })
        if(!(/^(?:(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])).{6,18}$/.test(this.dataForm.password))) {
          this.$message({
            type: 'warning',
            message: '您的密码过弱，建议您及时修改密码！',
            offset: 380,
            grouping: true
          })
        }
      } else {
        this.$post('/p/user/getUsersByAccountId', { id: accountId }).then(({ data }) => {
          if (data && data.code === 'C0000') {
            if (!data.result.length) {
              this.$message({
                type: 'error',
                message: '当前用户没有租户信息',
                offset: 380,
                grouping: true
              })
            } else if (data.result.length === 1){
              this.tenantId = 0
              this.tenants = data.result
              this.setTenant(data.result[0].isOuter)
            } else {
              this.dialog = true
              this.tenants = data.result
            }
          }
        })
      }
    },
    
    setAccount() {
      if (this.checked) {
        var curTime = new Date().getTime()
        localStorage.setItem(
          'information',
          JSON.stringify({ data: this.dataForm, time: curTime })
        );
      }
    },

    setTenant(isOuter) {
      // userId
      let userId = this.tenants[this.tenantId].id
      this.ActionsUserId(userId);
      // tenantId
      this.ActionsTenantId(this.tenants[this.tenantId].tenantId)
      this.setTenantState = true

      this.$post('/p/tenant/checkTenant', { id: this.tenants[this.tenantId].tenantId }).then(({ data }) => {
        this.setTenantState = false
        if(!(/^(?:(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])).{6,18}$/.test(this.dataForm.password))) {
          this.$message({
            type: 'warning',
            message: '您的密码过弱，建议您及时修改密码！',
            offset: 380,
            grouping: true
          })
        }
        // 初始化sessionStorage数据
        this.$initSessionStorageData.init().then(() => {
          
          this.$router.replace({
            path: '/',
            query: { isOuter: isOuter ? isOuter : '' }
          })
        })
      })
    },

    checkedPhoneCode() {
      if(!/^1[0-9]{10}$/.test(this.dataForm.username)) {
        return
      }
      this.isCodeDisabled = true
      let that = this

      this.$get('/p/message/mobile/sendMobileCode', { mobile: this.dataForm.username }).then(({ data }) => {
        if (data && data.code === 'C0000') {
          let index = 60
          let codeTime = setInterval(() => {
            if (index <= 0) {
              clearInterval(codeTime)
              that.isCodeDisabled = false
              that.phoneCodeBtn = '获取手机验证码'
            } else {
              this.phoneCodeBtn = '重新获取(' + index + ')'
              index--
            }
          }, 1000);
        } else {
          this.isCodeDisabled = false
        }
      })
    },

    regSubmit() {
      this.$refs.dataForm.validate(valid => {
        if (valid) {
          this.isloading = true
          this.$post('/gateway/mobileCaptchaLogin', {
            username: this.dataForm.username,
            captcha: this.dataForm.captcha,
            cnAddress: this.cnAddress,
            loginRemoteIp: this.loginRemoteIp,
            loginMode: 'sj',
            clientSource: '2',
            spreadChannelId: this.routeQuery.spreadChannelId,
            spreadUserId: this.routeQuery.spreadUserId,
          }).then(({ data }) => {
            if (data && data.code === 'C0000') {
              if(!data.result.loginAuthDto.isChangedPwd) {
                this.password.show = true
                this.password.data.userId = data.result && data.result.loginAuthDto ? data.result.loginAuthDto.userId || '' : ''
                return
              }
              this.authAfter(data)
            }
          }).finally(() => {
            setTimeout(() => {
              this.isloading = false
            }, 1000)
          })
        }
      })
    },

    switchWechatLogin() {
      this.loginWay = 'wechat'
      this.$nextTick(() => {
        this.wechatLoginInit()
      })
    },

    wechatLoginInit() {
      let ba64Css =
        'LmltcG93ZXJCb3gge3dpZHRoOiAyMDBweDt9Ci5pbXBvd2VyQm94IC5xcmNvZGUge3dpZHRoOiAyMDBweDttYXJnaW46IDA7fQouaW1wb3dlckJveCAudGl0bGUge2Rpc3BsYXk6IG5vbmU7fQouaW1wb3dlckJveCAuaW5mbyB7d2lkdGg6IDIwMHB4O30KLmltcG93ZXJCb3ggLnN0YXR1cyB7cGFkZGluZzogMDt0ZXh0LWFsaWduOiBjZW50ZXI7fQouaW1wb3dlckJveCAuc3RhdHVzIC5zdGF0dXNfaWNvbiB7ZGlzcGxheTogbm9uZTt9';
      new WxLogin({
        id: 'loginQrcode',
        appid: 'wx8fb4cc515ed2c998',
        scope: 'snsapi_login',
        redirect_uri: this.redirect_uri,
        state: '',
        style: '',
        sandbox: 'allow-scripts allow-top-navigation allow-same-origin',
        href: 'data:text/css;base64,' + ba64Css
      });
      this.$router.push({ path: '/login' })
    },

    wechatQRCodeLogin(code) {
      if (Array.isArray(code)) {
        code = code.pop()
      }
      let data = {code}
          data.cnAddress = this.cnAddress
          data.loginRemoteIp = this.loginRemoteIp
          data.loginMode = 'sm'
          data.clientSource = '2'

      this.$post('/gateway/wechatQRCodeLogin', data).then(({ data }) => {
        if (data && data.code === 'C0000') {
          this.bindForm.openId = data.result.openId
          this.$message({
            type: 'success',
            message: '扫码成功！',
            offset: 380,
            grouping: true
          })
          if (data.result.isBindWechat) {
            this.authAfter(data)
          } else {
            this.bindDialog = true
          }
        } else {
          this.wechatLoginInit()
        }
      }).catch(() => {
        this.wechatLoginInit()
      })
    },

    bindFormSubmit() {
      this.$refs.bindForm.validate(valid => {
        if (valid) {
          this.bindLoading = true
          this.$post('/gateway/auth', {
            username: this.bindForm.userName,
            password: this.bindForm.password,
            loginType: 'pc',
            loginMode: 'sm',
            clientSource: '2',
            cnAddress: this.cnAddress,
            loginRemoteIp: this.loginRemoteIp,
            openId: this.bindForm.openId
          }).then(({ data }) => {
            if (data && data.code === 'C0000') {
              if (data.result.isPwdExpired) {
                this.password.show = true
              } else {
                this.authAfter(data)
              }
            }
          }).finally(e => {
            setTimeout(() => {
                this.bindLoading = false
            }, 1000)
          })
        }
      });
    },

    bindDialogClose() {
      this.bindDialog = false
      this.wechatLoginInit()
    },
    
    closePassword() {
      this.$refs.passwordForm.resetFields()
      this.password.show = false
      this.$post('/p/user/logout').then(({ data }) => {
        this.$router.go(0)
      })
    },

    resetPassword() {
      this.$refs.passwordForm.validate(valid => {
        if (valid) {
          this.loading = true;
          let url = '/p/loginAccount/updatePwdByAccount'
          let data = {
            username: this.dataForm.userName,
            password: this.dataForm.password,
            newPassword: this.password.data.pass,
            confirmPassword: this.password.data.checkPass
          };
          if(this.loginWay === 'phone') {
            data.id = this.password.data.userId
            url = '/p/user/resetPassword'
          }
          this.$post(url, data).then(({ data }) => {
            if (data && data.code === 'C0000') {
              this.$message({
                type: 'success',
                message: data.message,
                offset: 380,
                grouping: true
              })
              this.dataForm.userName = this.loginWay === 'phone' ? this.dataForm.username : this.dataForm.userName
              this.dataForm.password = this.password.data.pass
              setTimeout(() => {
                this.loginSubmit()
                this.closePassword()
              }, 1000)
            }else{
              this.$message.error(data.message)
            }
          })
        }
      })
    },

    ...mapActions([
      'ActionsLoginId',
      'ActionsUserId',
      'ActionsTenantId',
      'ActionsUpdateName'
    ])
  }
};
</script>

<style lang="scss">
.login {
  position: relative;
  display: table;
  width: 100%;
  height: 100%;
  background-image: url(@/assets/img/login-bg.png);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  .logo {
    background-image: url(@/assets/img/login-logo.png);
    height: 70px;
    width: 194px;
    position: absolute;
    left: 35px;
    top: 35px;
  }
  .login-content {
    position: sticky;
    width: 480px;
    height: 560px;
    left: 65%;
    top: 12%;
    text-align: left;
    color: #000;
    .lc-name {
      font-size: 30px;
    }
    .lc-main {
      width: 480px;
      // height: 497px;
      margin-top: 32px;
      padding: 40px;
    //   box-shadow: 0px 3px 43px 0px rgba(0,0,0,0.1);
      box-shadow: 0px 3px 15px 0px rgb(0 0 0 / 25%);
      border-radius: 12px;
      .way {
        margin-bottom: 38px;
        display: flex;
        span {
          flex: 1;
          text-align: center;
          display: inline-block;
          height: 40px;
          font-size: 20px;
          cursor: pointer;
          &.active {
            color: #0A7CFF;
            background: url(@/assets/img/way-active.png) no-repeat bottom center;
          }
          // & + span {
          //   margin-left: 36px;
          // }
        }
      }
      .el-form-item {
        .el-input {
          font-size: 16px;
          .el-input__wrapper {
            box-shadow: none;
            border-radius: 8px;
            background: #F0F2F5;
            .el-input__inner {
              height: 60px;
            }
          }
          .el-input-group__append {
            box-shadow: none;
          }
        }
        &:nth-child(3) {
          margin: 37px 0 7px;
        }
        &.checked {
          margin-bottom: 0;
          .el-form-item__content {
            display: flex;
            justify-content: space-between;
            font-size: 16px;
            .el-checkbox__label {
              font-size: 16px;
            }
            .forgot-password {
              color: #0A7CFF;
              cursor: pointer;
              .line{
                width: 1px;
                height: 12px;
                background-color: #ccc;
                display: inline-block;
                margin-top: 3px;
              }
            }
          }
        }
      }
      .login-btn-submit {
        width: 100%;
        height: 60px;
        margin-top: 27px;
        border-radius: 8px;
        background: #0A7CFF;
        font-size: 16px;
      }
      .scan-login {
        p{
          font-size: 16px;
          margin-top: 15px;
          display: flex;
          justify-content: center;
          align-items: center;
          .icon-svg{
            color: #ff680d;
            width: 20px;
            height: 20px;
            margin-right: 2px;
          }
          span {
            cursor: pointer;
            color: #0a7cff;
          }
        }
      }
      .login-qrcode {
        width: 202px;
        height: 250px;
        overflow: hidden;
        margin: 0 auto;
        margin-top: 40px;
        margin-bottom: 15px;
        iframe {
          width: 202px;
          .wrp_code {
            .lightBorder {
              width: 100px;
            }
          }
        }
        img {
          height: 100px;
        }
      }
      .sign-tips{
        background-color:#feeae3;
        color: #F87243;
        height: 28px;
        line-height: 28px;
        border-radius: 8px;
        text-indent: 11px;
        font-size: 14px;
        margin-top: 11px;
      }
    }
  }
  .about {
    position: absolute;
    top: 35px;
    right: 35px;
    font-size: 16px;
    i {
      display: inline-block;
      width: 16px;
      height: 16px;
      margin: 4px 8px 0 0;
      vertical-align: top;
      background: url(@/assets/img/about.png) no-repeat;
    }
    a {
      color: #111;
      text-decoration: none;
    }
  }
}
</style>
